import { images } from ".";

const partners = [
    images.sponsor1,
    images.sponsor2,
    images.sponsor3,
    images.sponsor4,
    images.sponsor5,
    images.sponsor6,
    images.sponsor7,
    images.sponsor8,
    images.sponsor9,
    images.sponsor10,
    images.sponsor11,
    images.sponsor12,
];

export default partners;